import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {IAvailableLocationDiscount, mergeAndAdd} from '../../store';
import {IBaseResponse, WebService} from '../../services';

export interface ILocationDiscountStoreState {
	locationDiscounts: IAvailableLocationDiscount[];
}

@Module({name: 'locationDiscounts', namespaced: true})
class LocationDiscountModule extends VuexModule implements ILocationDiscountStoreState {
	locationDiscounts: IAvailableLocationDiscount[] = [];

	@Action
	async fetchLocationDiscounts(locationId: string) {
		// This request can fire right as the app starts up so it need to wait for
		// the logged in client to be ready.
		await WebService.loggedInStarted;
		const response = await WebService.authenticatedClient.get<IBaseResponse<{discounts: IAvailableLocationDiscount[]}>>(`locations/${locationId}/discounts`);
		this.setLocationDiscounts(response.data.data.discounts);
	}

	@Mutation
	public setLocationDiscounts(locationDiscounts: IAvailableLocationDiscount[]) {
		this.locationDiscounts = locationDiscounts;
	}

	@Mutation
	public addLocationDiscount(locationDiscount: IAvailableLocationDiscount) {
		mergeAndAdd(this.locationDiscounts, [locationDiscount], ['id']);
	}

	@Mutation
	public clearLocationDiscounts() {
		this.locationDiscounts = [];
	}
}


export {
	LocationDiscountModule
};
